import {gql} from '@apollo/client/core';

export const managePlanQuery = gql`
  query ManagePlanQuery {
    me {
      id
      appliedDiscountCancelationOn
      customerAccount {
        id
        subscription {
          id
          email
          hasActiveSubscription
          hasMembership
          status
          discounts {
            title
            amount
            category
            productVariantId
            type
          }
          items {
            id
            productId
            variantId
            variantSku
            title
            quantity
            price
          }
          pausedProductVariantIds
          nextBillingAttemptAt
        }
      }
    }
  }
`;

export const ProductDetailsQuery = gql`
  query ProductDetailsQuery {
    store {
      productVariants {
        id
        tid
        sku
        title
        type
        price
        packageType
        productId
        product {
          id
          tid
          title
          category
          thumbnail
          displayOrder
          variantIds
        }
      }
    }
  }
`;

export const GetDiscountQuery = gql`
  query GetDiscount($code: String!) {
    getDiscount(code: $code) {
      discountCode
    }
  }
`;
